module["exports"] = [
  "#{prefix} #{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pl/name/name.js
 ** module id = 831
 ** module chunks = 0
 **/